const errorMessages = {
  code: {
    not_found: {
      title: 'Weryfikacja',
      message: 'Wpisany kod jest niepoprawny',
    },
  },
};

export const prepareErrorMessageForNotAcceptableStatus = (errorData) => {
  // get only first error
  const mismatchValue = Object.keys(errorData)[0];
  const mismatchType = errorData[mismatchValue][0];

  return errorMessages[mismatchValue]
    ? errorMessages[mismatchValue][mismatchType] : {
      title: 'Błąd',
      message: 'Brak informacji na temat napotkanego błędu',
    };
};
